/**
 * Safe formatters that tolerate null, undefined or invalid input without
 * crashing the render or dumping "Invalid Date" / "NaN" to the user.
 */

const isValid = (d) => d instanceof Date && !isNaN(d.getTime());

const parse = (input) => {
  if (input == null || input === '') return null;
  const d = input instanceof Date ? input : new Date(input);
  return isValid(d) ? d : null;
};

export const safeDate = (input, opts = { day: '2-digit', month: '2-digit', year: 'numeric' }, fallback = '') => {
  const d = parse(input);
  return d ? d.toLocaleDateString('es-AR', opts) : fallback;
};

export const safeDateTime = (input, opts = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }, fallback = '') => {
  const d = parse(input);
  return d ? d.toLocaleString('es-AR', opts) : fallback;
};

export const safeTime = (input, opts = { hour: '2-digit', minute: '2-digit' }, fallback = '') => {
  const d = parse(input);
  return d ? d.toLocaleTimeString('es-AR', opts) : fallback;
};

export const safeNumber = (input, fallback = 0) => {
  if (input == null || input === '') return fallback;
  const n = typeof input === 'number' ? input : Number(input);
  return Number.isFinite(n) ? n : fallback;
};

export const safeMoney = (input, currency = 'ARS', opts = { maximumFractionDigits: 0 }) => {
  const n = safeNumber(input, 0);
  return `${currency || 'ARS'} ${n.toLocaleString('es-AR', opts)}`;
};
